/**
 * Validates that a radio button has been selected.
 */
export const Validator = {
    name: "radio",
    isImplicit: true,
    errorMessage: "You should select one of the options.",
    validate: value => !!value,
};
